/*
  Notify Me for sold-out knives. Goes with snippets/acre-notify-me.liquid, which puts the button
  under the greyed-out Sold Out button and the email popup right after the product form.
  It's loaded on every page from layout/theme.liquid and listens at the document level, because
  Quick view inserts the product form without running the scripts inside it.
  A sign-up is a Klaviyo back-in-stock request for the chosen variant, and Klaviyo's Back in Stock
  flow sends the restock email. XNZ74q is Acre's public Klaviyo site ID.
*/
(function () {
  if (window.acreNotifyMe) return;
  window.acreNotifyMe = true;

  var KLAVIYO_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XNZ74q';
  var escapeInPopup = false;

  function isIcon(title) {
    return /^icon\s/i.test(title || '');
  }

  // The button is inside the product form and its popup comes right after the form.
  function popupFor(button) {
    var form = button.closest('form');
    return form && form.parentElement.querySelector('dialog.acre-notify');
  }

  function showError(popup, message) {
    var error = popup.querySelector('[data-notify-error]');
    error.textContent = message;
    error.hidden = !message;
  }

  function open(button) {
    var popup = popupFor(button);
    if (!popup) return;
    var form = popup.querySelector('[data-notify-form]');
    var title = button.dataset.variantTitle;
    popup.dataset.variantId = button.dataset.variantId;
    form.hidden = false;
    popup.querySelector('[data-notify-done]').hidden = true;
    showError(popup, '');
    popup.querySelector('[data-notify-variant]').textContent = title && title !== 'Default Title' ? title : '';
    // Quick view renames ids, so point the popup's label at its heading again.
    popup.setAttribute('aria-labelledby', form.querySelector('.acre-notify__title').id);
    popup.showModal();
    form.querySelector('input[type="email"]').focus();
  }

  function submit(form) {
    var popup = form.closest('dialog');
    var email = form.querySelector('input[type="email"]');
    var button = form.querySelector('[data-notify-submit]');
    var address = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) {
      showError(popup, 'Please enter a valid email address.');
      email.focus();
      return;
    }
    showError(popup, '');
    button.disabled = true;

    fetch(KLAVIYO_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: address } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + popup.dataset.variantId } }
          }
        }
      })
    })
      .then(function (response) {
        if (response.status === 400) throw new Error('email');
        if (!response.ok) throw new Error('server');
        var done = popup.querySelector('[data-notify-done]');
        done.querySelector('[data-notify-email]').textContent = address;
        form.hidden = true;
        done.hidden = false;
        done.querySelector('button').focus();
      })
      .catch(function (err) {
        showError(
          popup,
          err.message === 'email'
            ? 'Please check your email address and try again.'
            : 'Something went wrong. Please try again in a moment.'
        );
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var button = evt.target.closest('[data-notify-open]');
    if (button) {
      open(button);
      return;
    }
    var popup = evt.target.closest('dialog.acre-notify');
    if (popup && (evt.target === popup || evt.target.closest('[data-notify-close]'))) popup.close();
  });

  document.addEventListener('submit', function (evt) {
    if (!evt.target.matches('[data-notify-form]')) return;
    evt.preventDefault();
    submit(evt.target);
  });

  // The theme fires variantChange on the product section whenever the chosen variant changes.
  // The event doesn't bubble, so it's caught on its way down to the section.
  document.addEventListener('variantChange', function (evt) {
    var section = evt.target;
    var variant = evt.detail && evt.detail.variant;
    if (!section.querySelectorAll) return;
    section.querySelectorAll('[data-notify-open]').forEach(function (button) {
      if (button.closest('[data-section-type="product"]') !== section) return;
      var show = !!variant && !variant.available && !(button.dataset.iconOnly === 'true' && !isIcon(variant.title));
      if (variant) {
        button.dataset.variantId = variant.id;
        button.dataset.variantTitle = variant.title;
      }
      button.style.display = show ? '' : 'none';
      var popup = popupFor(button);
      if (!show && popup && popup.open) popup.close();
    });
  }, true);

  // Escape closes the popup. Quick view closes on the same key's keyup, so that keyup stops here.
  window.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') escapeInPopup = !!document.querySelector('dialog.acre-notify[open]');
  }, true);
  window.addEventListener('keyup', function (evt) {
    if (evt.key === 'Escape' && escapeInPopup) {
      escapeInPopup = false;
      evt.stopPropagation();
    }
  }, true);
})();
